enum AnalyticsEventLocation {
  MAIN_LIST = `main_list`,
  SONG_DETAILS = `song_detail_page`,
  MINI_AUDIO_PLAYER = `mini_audio_player`,
  LIBRARY = `music_library_list`,
  SIDEBAR = `sidebar`,
  AI_GENERATED_SONG_DETAILS = `track_detail`,
  AI_MUSIC_GENERATOR = `ai_music_generator`,
  DISCOVERY_PAGE = 'discovery_page',
  DOWNLOAD_MODAL = 'download_modal',
  NAVIGATION_BAR = 'navigation_bar',
  STUDIO = 'studio',
  RELEASES = 'releases',
  RELEASE_REVIEW_PAGE = 'release_review_page',
  RELEASE_TILE = 'release_tile',
  NEW_RELEASE_MODAL = 'new_release_modal',
  WITHDRAW = 'withdraw',
  UPGRADE_DISTRIBUTION_MODAL = 'upgrade_distribution_modal',
  DOWNLOAD_LIMIT_REACHED_MODAL = 'download_limit_reached_modal',
  ACCOUNT_YOUTUBE_CHANNEL = 'account_youtube_channel',
  SUBSCRIPTION_PAGE = 'subscription_page',
}

export default AnalyticsEventLocation;
